
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const toggleScrolled = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, { passive: true });
  }

  const menuBtn = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('#MobileMenu');

  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      mobileMenu.style.display = open ? 'none' : 'block';
      mobileMenu.setAttribute('aria-hidden', String(open));
    });
  }

  document.querySelectorAll('[data-sort-by]').forEach(select => {
    select.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    });
  });
});
